import {ADDRESS_REGEXP} from './constants/validation'
const ADDRESS_FIELD_NAMES = ['address1', 'address2', 'city', 'stateCode', 'c_customerAddressID'];

export const validateShippingAddress = (address?: any) => {
  return {
    isValid: ADDRESS_FIELD_NAMES.every(field => {
      if (field === 'address2' && !address[field] || field === 'stateCode' && !address[field]) {
        return true;
      }
      return address[field] && ADDRESS_REGEXP.test(address[field]);
    }),
  }
}
